import React, { useEffect, useState } from 'react';
import api from '../api';
import { Header } from './Dashboard';

export default function Transactions() {
  const [txns, setTxns] = useState([]);

  useEffect(() => {
    api.get('/admin/transactions').then((d) => setTxns(d.transactions));
  }, []);

  const total = txns.filter((t) => t.status === 'success').reduce((sum, t) => sum + t.amountInr, 0);

  return (
    <div>
      <Header title="Revenue & Transactions" sub={`Total collected: ₹${total.toLocaleString('en-IN')}`} />
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table>
          <thead>
            <tr><th>User</th><th>Plan</th><th>Amount</th><th>Gateway</th><th>Status</th><th>Date</th></tr>
          </thead>
          <tbody>
            {txns.map((t) => (
              <tr key={t._id}>
                <td style={{ color: '#fff' }}>{t.user?.name || '—'}<div style={{ fontSize: 12, color: 'var(--text-muted)' }}>+{t.user?.phone}</div></td>
                <td>{t.plan?.name} <span className="badge premium" style={{ marginLeft: 6 }}>{t.plan?.tier}</span></td>
                <td style={{ color: 'var(--like)', fontWeight: 700 }}>₹{t.amountInr}</td>
                <td style={{ textTransform: 'capitalize' }}>{t.gateway}</td>
                <td><span className={`badge ${t.status === 'success' ? 'active' : 'incomplete'}`}>{t.status}</span></td>
                <td>{new Date(t.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
            {txns.length === 0 ? <tr><td colSpan={6} style={{ textAlign: 'center', padding: 30 }}>No transactions yet.</td></tr> : null}
          </tbody>
        </table>
      </div>
    </div>
  );
}
